import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { withRouter, useHistory, Redirect } from 'react-router-dom'
import { categoriesActions } from '../../actions/categoriesActions'
import { departamentsActions } from '../../actions/departamentsActions'
import { positionsActions } from '../../actions/positionsActions'
import { specialtiesActions } from '../../actions/specialtiesActions'
import { usersActions } from '../../actions/usersActions'
import { routes } from '../../constantes/routes'
import Header from '../header/Header'
import '../../assests/styles/backoffice/BackOffice.scss'

const BackOffice = () => {
  const history = useHistory()
  const userProfile = useSelector((state) => state.userProfile)

  const dispatch = useDispatch()
  const getAllPositions = () => dispatch(positionsActions.getAllPositions())
  const getAllSpecialties = () =>
    dispatch(specialtiesActions.getAllSpecialties(0))
  const getAllUsers = () => dispatch(usersActions.getAllUsers())
  const getAllDepartaments = () =>
    dispatch(departamentsActions.getAllDepartaments())
  const getAllCategories = () => dispatch(categoriesActions.getAllCategories())

  useEffect(() => {
    getAllPositions()
    getAllSpecialties()
    getAllUsers()
    getAllDepartaments()
    getAllCategories()
  }, [])
  const toProducts = () => {
    history.push(routes.PRODUCTS)
  }

  const toHospitals = () => {
    history.push(routes.HOSPITALS)
  }

  const toDepartments = () => {
    history.push(routes.DEPARTMENTS)
  }

  const toPositions = () => {
    history.push(routes.POSITIONS)
  }

  const toUsers = () => {
    history.push(routes.USERS)
  }

  const toSpecialties = () => {
    history.push(routes.SPECIALTIES)
  }

  const toMain = () => {
    history.push(routes.MAIN)
  }

  const toCategories = () => {
    history.push(routes.CATEGORIES)
  }

  const toBusinessUnits = () => {
    history.push(routes.BUSINESSUNITS)
  }

  const toConfig = () => {
    history.push(routes.CONFIGURACIONES)
  }

  return (
    <>
      {userProfile.roles.isBackofficeVer ? (
        <div className='backoffice-page'>
          <Header text='Backoffice' route={toMain} backBtn={true} />
          <div className='backoffice__container'>
            <div className='backoffice__content'>
              <div className='backoffice__grid'>
                {userProfile.roles.isBackofficeVer && (
                  <>
                    {/* Primera fila - 4 cards principales */}
                    <button className='backoffice__card' onClick={toProducts}>
                      <h3 className='backoffice__card-title'>
                        Gestionar productos
                      </h3>
                    </button>

                    <button className='backoffice__card' onClick={toCategories}>
                      <h3 className='backoffice__card-title'>
                        Categorías productos
                      </h3>
                    </button>

                    {userProfile.roles.codigo <= 2000 && ( /* Administrador o superior */
                      <button className='backoffice__card' onClick={toHospitals}>
                        <h3 className='backoffice__card-title'>Hospitales / Centros</h3>
                      </button>
                    )}

                    {userProfile.roles.codigo <= 2000 && ( /* Administrador o superior */
                      <button
                        className='backoffice__card'
                        onClick={toDepartments}
                      >
                        <h3 className='backoffice__card-title'>Departamento</h3>
                      </button>
                    )}

                    {/* Segunda fila - 4 cards secundarias */}
                    {userProfile.roles.codigo <= 2000 && ( /* Administrador o superior */
                      <button className='backoffice__card' onClick={toPositions}>
                        <h3 className='backoffice__card-title'>Cargos</h3>
                      </button>
                    )}

                    {userProfile.roles.codigo <= 2000 && ( /* Administrador o superior */
                      <button
                        className='backoffice__card'
                        onClick={toSpecialties}
                      >
                        <h3 className='backoffice__card-title'>
                          Especialidades
                        </h3>
                      </button>
                    )}

                    <button className='backoffice__card' onClick={toUsers}>
                      <h3 className='backoffice__card-title'>Usuarios</h3>
                    </button>

                    {userProfile.roles.codigo <= 2000 && ( /* Administrador o superior */
                      <button
                        className='backoffice__card'
                        onClick={toBusinessUnits}
                      >
                        <h3 className='backoffice__card-title'>
                          Unidades de Negocio
                        </h3>
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Redirect to={{ pathname: routes.MAIN }} />
      )}
    </>
  )
}

export default withRouter(BackOffice)
